var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';






const EntityFilter = ({ filterGroups, setFilters }) => {
  const handleFilterChange = (isChecked, groupKey, optionKey) => {
    console.log(isChecked, groupKey, optionKey);
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0,
    filterGroups.map((group) => /*#__PURE__*/
    _jsx("div", { className: "p-4 rounded-lg  shadow-sm" }, group.label, /*#__PURE__*/
    _jsx("h2", { className: "text-sm font-semibold font-roboto text-gray-900 mb-3" }, void 0, group.label), /*#__PURE__*/
    _jsx("div", { className: "space-y-2" }, void 0,
    group.options.map((option) => /*#__PURE__*/
    _jsx("label", { className: "flex items-center" }, option.label, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      checked: false,
      onChange: (e) => {
        handleFilterChange(e.target.checked, group.key, option.key);
      },
      className: "h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" }
    ), /*#__PURE__*/
    _jsx("span", { className: "ml-3 flex flex-1 justify-between items-center text-sm text-gray-600" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-xs font-roboto" }, void 0, option.label), /*#__PURE__*/
    _jsx("div", { className: "border-b border-dashed border-gray-[#E8E7EC] mx-2 flex-grow" }), /*#__PURE__*/
    _jsx("span", { className: "text-xs font-roboto font-bold" }, void 0, option.count)
    )
    )
    )
    )
    )
    )
    ));

};

export { EntityFilter };